export default [
  {
    title: "Verifica valabilitate",
    text: "Acceseaza site-ul RAROM pentru a verifica valabilitatea ITP",
  },
  {
    title: "Alege o locatie",
    text:
      "Alege una dintre locatiile noastre ITP din Ploiesti, Ciorani sau Floresti",
  },
  {
    title: "Programeaza-te",
    text: "Contacteaza-ne telefonic pentru a te programa pentru ITP",
  },
  {
    title: "Te asteptam",
    text:
      "Cei mai pregatiti inspectori ITP te asteapta pentru siguranta masinii tale",
  },
]
